import React, { Fragment, useState } from "react";
import SearchBooking, { SearchContext } from "../search/searchBooking";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { useTheme, IconButton, useMediaQuery } from "@mui/material";

import flex from "../../../../styles/flex";
import fonts from "../../../../styles/fonts";
import propTypes from "prop-types";
import styles from "./styles";
import { useContext } from "react";
import { SessionContext } from "../../../../utility/useSession";
import UserDetailDialog from "../../../../components/users/UserDetailDialog";
import Updates from "./updates/updates";
import { User } from "../../../../logic/api";
import CarParkSwitcher from "../carParkSwitcher/CarParkSwitcher";
import { FiHome, FiUser } from "react-icons/fi";
import AlertsView from "../alertsView/AlertsView";
import AlertsViewV2 from "../alertsView/AlertsViewV2";
import { useTranslation } from "react-i18next";
import { HelpCentre } from "../../../../components/icons/help-centre";
import { ReleaseFlag, useReleaseManagement } from "../../../../utility/feature-management";
import { useRoles } from "@/components/users/rolesAndPermissions/useRoles";

const Header: React.FunctionComponent<{
  showNav: boolean;
  setShowNav: (value: boolean) => void;
}> = (props) => {
  const { t } = useTranslation();
  const session = useContext(SessionContext);
  const theme = useTheme();
  const isDesktopWidth = useMediaQuery(theme.breakpoints.up("md"));
  const searchContext = useContext(SearchContext);

  const [showUserDialog, setShowUserDialog] = useState(false);
  const [showCarParkSwitcher, setShowCarParkSwitcher] = useState(false);

  const [userDialogUser, setUserDialogUser] = useState<User | null>(null);
  const headerLinkFlag = useReleaseManagement(ReleaseFlag.releaseHelpCentreLinkForHeader);
  const { data: rolesData } = useRoles();
  const availableRoles = rolesData?.roles || [];

  const isAlertsHookRefactorReleased = useReleaseManagement(ReleaseFlag.releaseAlertsHookRefactor);

  const endSearch = () => {
    if (searchContext.setCriteria) {
      searchContext.setCriteria({
        search: "",
        cancelled: false,
        exact: false,
        show: false,
      });
    }
    props.setShowNav(true);
  };

  let showSearch = false;
  let searchText = "";
  if (searchContext.criteria) {
    showSearch = searchContext.criteria.show;
    searchText = searchContext.criteria.search;
  }

  let currentSite = "";

  if (session.current.site == null) {
    return <Fragment />;
  }

  if (session.current.site.home != null) {
    if (session.current.credential != null) {
      currentSite = session.current.credential.database;
    }
    currentSite = `${currentSite} (${session.current.site.home.name})`;
  }

  const displayUserDialog = () => {
    if (session.current.site == null) {
      return;
    }
    setUserDialogUser(JSON.parse(JSON.stringify(session.current.site.user)));
    setShowUserDialog(true);
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        {session.current.site != null && (
          <Fragment>
            <UserDetailDialog
              show={showUserDialog}
              user={userDialogUser}
              availableRoles={availableRoles}
              onClose={(didUpdate, user) => {
                setShowUserDialog(false);
                if (didUpdate) {
                  if (session.current.site) {
                    if (user) {
                      session.setUser(user);
                    }
                  }
                }
              }}
            ></UserDetailDialog>
            <CarParkSwitcher
              show={showCarParkSwitcher}
              onClose={() => {
                setShowCarParkSwitcher(false);
              }}
            ></CarParkSwitcher>
          </Fragment>
        )}

        {isDesktopWidth == false && showSearch == false && (
          <Fragment>
            {props.showNav == false && (
              <div style={flex.flexAuto}>
                <IconButton
                  onClick={() => {
                    props.setShowNav(true);
                  }}>
                  <MenuIcon />
                </IconButton>
              </div>
            )}

            <div style={styles.userDetails}>
              <div>{`${session.current.site.user.firstName} ${session.current.site.user.lastName}`}</div>
              <div style={{ textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                <b>{currentSite}</b>
              </div>
            </div>
            <div
              style={{ ...flex.flexAuto }}
              onClick={() => {
                displayUserDialog();
              }}
            >
              <IconButton>
                <FiUser></FiUser>
              </IconButton>
            </div>
            <div
              style={{ ...flex.flexAuto }}
              onClick={() => {
                setShowCarParkSwitcher(true);
              }}
            >
              <IconButton>
                <FiHome></FiHome>
              </IconButton>
            </div>

            {headerLinkFlag && (
              <div
                style={{ ...flex.flexAuto }}>
                <HelpCentre />
              </div>
            )}

            <Updates />

            <div style={flex.flexAuto}>
              {isAlertsHookRefactorReleased ? <AlertsViewV2 /> : <AlertsView />}
            </div>
          </Fragment>
        )}

        {isDesktopWidth == true && (
          <Fragment>
            {showSearch == true && searchText.length > 0 && (
              <div style={{ ...flex.flexAuto, paddingLeft: 10 }}>
                <IconButton
                  onClick={() => {
                    endSearch();
                  }}>
                  <CloseIcon />
                </IconButton>
              </div>
            )}
            <div style={{ ...flex.flexAuto }}>
              <div style={styles.search}>
                <SearchBooking />
              </div>
            </div>

            <div style={{ ...flex.flexFill, ...styles.environment }}>
              {(session.options.environment !== "production") && (
                <div style={{ ...flex.flexAuto, cursor: "pointer" }}>
                  <div style={styles.loggedInAs}>
                    <span style={fonts.small}>{t("home.environment")}</span>
                    <div>
                      <strong>
                        {session.options.environment}
                      </strong>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div style={{ ...flex.flexAuto, cursor: "pointer" }}>
              <div style={styles.loggedInAs}>
                <span style={fonts.small}>{t("home.loggedInAs")}</span>
                <div>
                  <b>
                    {session.current.site.user != null &&
                      `${session.current.site.user.firstName} ${session.current.site.user.lastName}`}
                  </b>
                </div>
              </div>
            </div>

            <div style={{ ...flex.flexAuto, cursor: "pointer" }}>
              <div style={styles.workingAtSite}>
                <span style={fonts.small}>{t("home.workingAtSite")}</span>
                <div>
                  <b>{currentSite}</b>
                </div>
              </div>
            </div>
            <div style={{ ...flex.flexAuto }}>
              <div
                style={styles.notificationIcon}
                onClick={() => {
                  displayUserDialog();
                }}
              >
                <IconButton>
                  <FiUser></FiUser>
                </IconButton>
              </div>
            </div>
            <div
              style={{ ...flex.flexAuto }}
              onClick={() => {
                setShowCarParkSwitcher(true);
              }}
            >
              <div style={styles.notificationIcon}>
                <IconButton>
                  <FiHome></FiHome>
                </IconButton>
              </div>
            </div>

            {headerLinkFlag && (
              <div
                style={{ ...flex.flexAuto }}>
                <HelpCentre />
              </div>
            )}

            <div style={{ ...flex.flexAuto }}>
              <Updates />
            </div>

            <div style={{ ...flex.flexAuto }}>
              <div style={styles.notificationIcon}>
                {isAlertsHookRefactorReleased ? <AlertsViewV2 /> : <AlertsView />}
              </div>
            </div>
          </Fragment>
        )}
      </div>
      {isDesktopWidth == false && showSearch == true && (
        <div>
          <div style={flex.flexRows}>
            <div style={flex.flexAuto}>
              <IconButton
                onClick={() => {
                  endSearch();
                }}>
                <CloseIcon />
              </IconButton>
            </div>

            <div style={flex.flexFill}>
              <div style={styles.searchSm}>
                <SearchBooking />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Header.propTypes = {
  setShowNav: propTypes.func.isRequired,
  showNav: propTypes.bool.isRequired,
};

export default Header;
